import { IClient } from '../models/clients.models';

export const baseClientMock: IClient = {
  clientId: 'clientId1',
  salesforceId: 'salesforceId1',
  clientName: 'client Name',
  opportunities: {},
};
